// Shopify's language editor prepends a /* ... */ banner to this file, which
// arrives on every `theme pull` and is not valid JSON. Import it as raw text
// and strip the banner so a pull can't break the build.
import rawLocaleEn from '../../../locales/en.default.json?raw';

const SiteLocaleEn = JSON.parse(
  rawLocaleEn.replace(/^\s*\/\*[\s\S]*?\*\/\s*/, ''),
);

/**
 * This function can be used for locale translation in javascript files
 *
 * @param {string} string the translation string to be used. eg: 'product.sale'
 * @param {object} replacements an object with each key being the string to be replaced and the value being what to replace it with.
 */
const getTranslation = (string, replacements) => {
  const languages = {
    en: SiteLocaleEn,
  };

  let translation = string
    .split('.')
    .reduce((acc, cur) => acc[cur], languages[Shopify.locale]);

  if (replacements) {
    Object.entries(replacements).forEach(([key, val]) => {
      translation = translation.replaceAll(`{{ ${key} }}`, val);
    });
  }

  return translation;
};

export default getTranslation;
